import React from 'react';

const WebsiteBuilderExpertLogo = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 200 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    data-testid="websiteBuilderExpertLogo"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
  >
    <g id="Artboard1" transform="matrix(0.8,0,0,1,0,0)">
      <rect x="0" y="0" width="250" height="50" style={{ fill: 'none' }} />
      <g transform="matrix(0.106414,0,0,0.0851311,30.1798,44.3445)">
        <path
          d="M0,-166.971L-40.053,-53.321L-78.096,-166.953L-97.166,-166.953L-137.431,-53.321L-174.731,-166.971L-209.276,-166.971L-151.2,0L-126.667,0L-88.367,-105.889L-51.818,0L-27.287,0L34.545,-166.971L0,-166.971Z"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,51.8455,32.4318)">
        <path
          d="M0,116.402C-17.524,116.402 -30.039,102.885 -30.039,85.611C-30.039,68.339 -17.524,55.071 0,55.071C17.523,55.071 30.039,68.339 30.039,85.611C30.039,102.885 17.523,116.402 0,116.402M8.261,28.035C-1.002,28.035 -16.272,30.539 -27.035,45.558L-27.035,-27.037L-57.576,-27.037L-57.576,139.933L-27.035,139.933L-27.035,125.915C-15.27,142.186 0.501,143.439 7.51,143.439C39.552,143.439 61.581,118.655 61.581,85.611C61.581,52.819 40.303,28.035 8.261,28.035"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.106414,0,0,0.0851311,72.3123,33.2429)">
        <path
          d="M-0.001,-36.547C10.013,-36.547 18.274,-28.285 18.274,-18.273C18.274,-8.259 10.013,0 -0.001,0C-10.014,0 -18.275,-8.259 -18.275,-18.273C-18.275,-28.285 -10.014,-36.547 -0.001,-36.547"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,152.076,8.48018)">
        <path
          d="M0,0L-65.762,-70.176L-84.813,-90.505L-103.863,-70.176L-127.219,-45.253L-84.813,90.505L-32.171,34.33L0,0Z"
          style={{
            fill: 'rgb(14,177,210)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,137.449,13.2623)">
        <path
          d="M0,-21.844L-32.171,-56.174L-97.933,-126.35L-116.984,-146.679L-136.035,-126.35L-159.39,-101.427L-116.984,34.331L-71.692,82.662L-32.171,124.835L7.35,82.662L52.641,34.331L0,-21.844Z"
          style={{
            fill: 'rgb(140,99,239)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,119.398,13.2623)">
        <path
          d="M0,-21.844L-32.171,-56.174L-97.933,-126.35L-116.984,-146.679L-136.035,-126.35L-201.797,-56.174L-169.625,-21.844L-116.984,34.331L-71.692,82.662L-32.171,124.835L7.35,82.662L52.642,34.331L0,-21.844Z"
          style={{
            fill: 'rgb(30,100,255)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.0727647,0.0621183,0.0776479,-0.0582117,119.159,6.45505)">
        <path
          d="M-3.101,-38.098L43.947,-38.098L120.933,-38.098L-7.123,23.788L-3.101,-38.098Z"
          style={{
            fill: 'rgb(37,51,77)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.0727647,0.0621183,0.0776479,-0.0582117,137.209,6.45505)">
        <path
          d="M-3.101,-38.098L43.947,-38.098L120.933,-38.098L-7.123,23.788L-3.101,-38.098Z"
          style={{
            fill: 'rgb(37,51,77)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,35.2799,40.9559)">
        <path
          d="M0,-28.786C2.503,-43.307 14.268,-50.565 25.533,-50.565C36.798,-50.565 48.813,-43.556 51.317,-28.786L0,-28.786ZM24.782,-72.095C11.765,-72.095 -3.255,-69.339 -16.021,-56.824C-23.781,-49.063 -32.543,-35.797 -32.543,-14.267C-32.543,2.755 -27.537,16.774 -15.521,28.039C-4.756,38.301 8.511,43.309 26.034,43.309C63.834,43.309 76.1,17.524 79.354,9.513L51.317,5.008C46.311,13.769 37.549,19.277 26.034,19.277C14.268,19.277 7.51,13.519 4.256,9.012C0.75,4.256 -1.001,-2.753 -1.001,-9.261L80.105,-9.261L80.105,-11.765C80.105,-23.53 78.603,-40.551 67.088,-54.32C59.578,-63.332 46.811,-72.095 24.782,-72.095"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,64.974,40.9986)">
        <path
          d="M0,-29.788L-7.259,-32.042C-15.771,-34.796 -17.023,-39.052 -17.023,-41.805C-17.023,-47.062 -12.517,-50.565 -5.257,-50.565C-2.003,-50.565 5.257,-50.065 12.517,-43.307L27.536,-61.08C13.768,-71.594 1.001,-72.596 -7.01,-72.596C-15.771,-72.596 -26.786,-71.594 -35.296,-64.835C-41.555,-59.578 -46.562,-50.817 -46.562,-40.303C-46.562,-31.542 -43.307,-24.782 -38.301,-19.525C-31.792,-12.766 -22.781,-9.262 -15.02,-6.508L-8.01,-4.005C-4.005,-2.502 1.501,0.251 1.501,7.011C1.501,14.521 -5.007,18.776 -13.518,18.776C-22.53,18.776 -31.541,13.268 -37.55,6.259L-53.571,24.783C-46.812,32.042 -34.045,42.808 -11.515,42.808C1.752,42.808 12.266,39.302 21.028,31.292C29.789,23.281 33.043,13.519 33.043,3.755C33.043,-3.254 30.79,-9.763 27.536,-14.267C21.278,-22.779 8.511,-27.035 0,-29.788"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,3.32365,27.7029)">
        <rect
          x="633.035"
          y="87.089"
          width="30.541"
          height="108.393"
          style={{ fill: 'rgb(41,35,92)' }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,80.6631,44.3445)">
        <path
          d="M0,-145.441L-30.541,-145.441L-30.541,-108.393L-42.557,-108.393L-42.557,-82.358L-30.541,-82.358L-30.541,0L0,0L0,-82.358L21.028,-82.358L21.028,-108.393L0,-108.393L0,-145.441Z"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,86.8938,40.9559)">
        <path
          d="M0,-28.786C2.503,-43.307 14.268,-50.565 25.533,-50.565C36.798,-50.565 48.814,-43.556 51.317,-28.786L0,-28.786ZM24.782,-72.095C11.765,-72.095 -3.255,-69.339 -16.021,-56.824C-23.781,-49.063 -32.543,-35.797 -32.543,-14.267C-32.543,2.755 -27.537,16.774 -15.521,28.039C-4.757,38.301 8.511,43.309 26.034,43.309C63.834,43.309 76.1,17.524 79.354,9.513L51.317,5.008C46.311,13.769 37.549,19.277 26.034,19.277C14.268,19.277 7.51,13.519 4.256,9.012C0.75,4.256 -1.002,-2.753 -1.002,-9.261L80.106,-9.261L80.106,-11.765C80.106,-23.53 78.603,-40.551 67.088,-54.32C59.578,-63.332 46.811,-72.095 24.782,-72.095"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,104.952,32.7726)">
        <path
          d="M0,104.889C-7.26,109.144 -16.271,109.394 -22.279,109.394L-36.298,109.394L-36.298,63.334L-24.282,63.334C-17.273,63.334 -9.012,63.334 -2.002,66.588C8.511,71.344 10.264,80.356 10.264,85.614C10.264,92.122 8.01,100.133 0,104.889M-36.298,-4.506L-26.785,-4.506C-13.518,-4.506 -1.753,1.252 -1.753,16.521C-1.753,37.8 -22.029,38.301 -27.036,38.301L-36.298,38.301L-36.298,-4.506ZM10.013,46.812C14.519,44.308 28.788,35.547 28.788,14.019C28.788,-0.001 23.03,-13.017 13.268,-20.527C-0.25,-31.041 -18.274,-31.041 -27.537,-31.041L-68.841,-31.041L-68.841,135.93L-12.767,135.93C1.752,135.93 17.022,133.426 29.539,122.412C41.054,112.147 43.808,98.38 43.808,88.617C43.808,79.856 41.805,66.839 31.792,57.326C27.536,53.32 21.028,48.564 10.013,46.812"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,119.173,39.4217)">
        <path
          d="M0,10.764C0,16.522 -0.5,24.281 -6.509,29.788C-10.264,33.044 -16.271,35.296 -22.029,35.296C-27.787,35.296 -33.795,33.044 -37.55,29.788C-43.557,24.281 -44.058,16.522 -44.058,10.764L-44.058,-50.567L-74.599,-50.567L-74.599,15.77C-74.599,25.534 -73.347,38.551 -61.331,49.065C-51.317,57.826 -35.296,61.331 -22.029,61.331C-8.762,61.331 7.26,57.826 17.272,49.065C29.288,38.551 30.54,25.534 30.54,15.77L30.54,-50.567L0,-50.567L0,10.764Z"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(-0.106414,0,0,0.0851311,126.262,33.2429)">
        <path
          d="M-0.002,-36.547C10.012,-36.547 18.273,-28.285 18.273,-18.273C18.273,-8.259 10.012,0 -0.002,0C-10.015,0 -18.275,-8.259 -18.275,-18.273C-18.275,-28.285 -10.015,-36.547 -0.002,-36.547"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,3.32365,27.7029)">
        <rect
          x="1140.01"
          y="87.089"
          width="30.541"
          height="108.393"
          style={{ fill: 'rgb(41,35,92)' }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,3.32365,22.7161)">
        <rect
          x="1194.07"
          y="87.089"
          width="30.541"
          height="166.971"
          style={{ fill: 'rgb(41,35,92)' }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,142.107,32.4318)">
        <path
          d="M0,116.402C-17.522,116.402 -30.039,102.885 -30.039,85.611C-30.039,68.339 -17.522,55.071 0,55.071C17.523,55.071 30.04,68.339 30.04,85.611C30.04,102.885 17.523,116.402 0,116.402M27.036,45.558C16.772,29.537 0.501,28.035 -7.76,28.035C-39.802,28.035 -61.581,53.569 -61.581,85.611C-61.581,117.403 -39.552,143.439 -6.258,143.439C1.502,143.439 16.021,141.685 27.036,125.915L27.036,139.933L57.576,139.933L57.576,-27.037L27.036,-27.037L27.036,45.558Z"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,153.611,40.9559)">
        <path
          d="M0,-28.786C2.503,-43.307 14.269,-50.565 25.533,-50.565C36.798,-50.565 48.814,-43.556 51.317,-28.786L0,-28.786ZM24.782,-72.095C11.766,-72.095 -3.255,-69.339 -16.021,-56.824C-23.781,-49.063 -32.543,-35.797 -32.543,-14.267C-32.543,2.755 -27.537,16.774 -15.52,28.039C-4.756,38.301 8.512,43.309 26.034,43.309C63.834,43.309 76.1,17.524 79.354,9.513L51.317,5.008C46.311,13.769 37.549,19.277 26.034,19.277C14.269,19.277 7.51,13.519 4.256,9.012C0.75,4.256 -1.001,-2.753 -1.001,-9.261L80.106,-9.261L80.106,-11.765C80.106,-23.53 78.604,-40.551 67.088,-54.32C59.579,-63.332 46.812,-72.095 24.782,-72.095"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,172.931,30.13)">
        <path
          d="M0,166.971L92.622,166.971L92.622,138.933L32.543,138.933L32.543,93.373L90.119,93.373L90.119,65.337L32.543,65.337L32.543,28.038L92.622,28.038L92.622,0L0,0L0,166.971Z"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,196.398,44.3445)">
        <path
          d="M0,-108.354L-34.989,-108.354L-55.438,-80.327L-75.433,-108.354L-110.423,-108.354L-72.706,-59.058L-119.511,0L-84.067,0L-55.438,-37.787L-27.264,0L8.18,0L-38.397,-59.058L0,-108.354Z"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,206.703,42.3625)">
        <path
          d="M0,-8.011C-4.005,-4.256 -10.515,-0.25 -20.527,-0.25C-30.04,-0.25 -36.548,-4.005 -40.554,-7.511C-46.561,-12.766 -50.567,-21.028 -50.567,-31.041C-50.567,-41.053 -47.062,-48.565 -40.303,-54.321C-34.795,-59.328 -28.538,-61.581 -20.527,-61.581C-13.268,-61.581 -5.257,-58.828 0.25,-53.82C6.258,-48.064 9.513,-39.052 9.513,-31.041C9.513,-23.031 6.508,-14.018 0,-8.011M-12.266,-88.617C-32.293,-88.617 -42.806,-77.852 -47.563,-71.094L-47.563,-85.112L-78.104,-85.112L-78.104,80.606L-47.563,80.606L-47.563,9.263C-35.547,25.533 -20.277,26.786 -12.767,26.786C3.254,26.786 15.771,20.528 24.032,12.766C30.29,6.759 41.054,-6.509 41.054,-31.041C41.054,-52.569 32.793,-66.086 24.783,-74.097C12.517,-86.363 -2.753,-88.617 -12.266,-88.617"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,215.861,40.9559)">
        <path
          d="M0,-28.786C2.503,-43.307 14.269,-50.565 25.533,-50.565C36.798,-50.565 48.813,-43.556 51.317,-28.786L0,-28.786ZM24.782,-72.095C11.766,-72.095 -3.255,-69.339 -16.021,-56.824C-23.781,-49.063 -32.543,-35.797 -32.543,-14.267C-32.543,2.755 -27.536,16.774 -15.521,28.039C-4.756,38.301 8.51,43.309 26.034,43.309C63.834,43.309 76.101,17.524 79.354,9.513L51.317,5.008C46.311,13.769 37.549,19.277 26.034,19.277C14.269,19.277 7.51,13.519 4.256,9.012C0.75,4.256 -1.001,-2.753 -1.001,-9.261L80.105,-9.261L80.105,-11.765C80.105,-23.53 78.604,-40.551 67.088,-54.32C59.579,-63.332 46.812,-72.095 24.782,-72.095"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,230.694,43.9396)">
        <path
          d="M0,-102.386C-2.252,-101.133 -8.761,-96.628 -13.517,-87.366L-13.517,-103.637L-44.058,-103.637L-44.058,4.756L-13.517,4.756L-13.517,-47.312C-13.517,-54.823 -13.267,-64.085 -7.51,-71.345C-1.501,-78.855 7.01,-80.106 12.767,-80.106C19.026,-80.106 23.031,-78.855 27.036,-76.1L31.042,-104.638C27.537,-105.889 23.282,-107.142 18.024,-107.142C10.765,-107.142 4.756,-105.388 0,-102.386"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,239.852,41.1905)">
        <path
          d="M0,-71.345L0,-108.393L-30.541,-108.393L-30.541,-71.345L-42.557,-71.345L-42.557,-45.31L-30.541,-45.31L-30.541,37.048L0,37.048L0,-45.31L21.028,-45.31L21.028,-71.345L0,-71.345Z"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
      <g transform="matrix(0.106414,0,0,0.0851311,168.738,43.9396)">
        <path
          d="M0,-102.386C-2.252,-101.133 -8.761,-96.628 -13.517,-87.366L-13.517,-103.637L-44.058,-103.637L-44.058,4.756L-13.517,4.756L-13.517,-47.312C-13.517,-54.823 -13.267,-64.085 -7.509,-71.345C-1.501,-78.855 7.01,-80.106 12.767,-80.106C14.848,-80.106 16.677,-79.964 18.342,-79.678L18.342,-107.133C18.234,-107.134 18.133,-107.142 18.024,-107.142C10.765,-107.142 4.757,-105.388 0,-102.386"
          style={{
            fill: 'rgb(41,35,92)',
            fillRule: 'nonzero',
          }}
        />
      </g>
    </g>
  </svg>
);

export default WebsiteBuilderExpertLogo;
